import { render } from "./ContentPlaces.vue?vue&type=template&id=f7893e48"
import script from "./ContentPlaces.vue?vue&type=script&lang=js"
export * from "./ContentPlaces.vue?vue&type=script&lang=js"
script.render = render

export default script